import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose, AiOutlineLogout } from "react-icons/ai";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaHistory } from "react-icons/fa";
import Navbar from "react-bootstrap/Navbar";
import swal from "sweetalert";
import "../Admin/Admin.css";

const KarleLayout = (props) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  const logOut = () => {
    swal({ title: "Yeah!", text: "Successfully Logged Out", icon: "success", button: "Ok!" });
    localStorage.removeItem("karleAdmin");
    setShowLogout(false);
    setTimeout(() => {
      navigate("/karle-login");
    }, 1000);
  };

  return (
    <div>
      <div className="dash">
        <div className="admin-all">
          <div className="admin-sidebar-display">
            <div className="left-side" style={{ position: "sticky", top: "0", height: "100vh", width: "250px" }}>
              <Navbar expand="lg" className="p-0">
                <button
                  className="custom-toggler navbar-toggler"
                  type="button"
                  onClick={() => setIsNavCollapsed(!isNavCollapsed)}
                  style={{ margin: "10px" }}
                >
                  <span>
                    <GiHamburgerMenu style={{ color: "white" }} />
                  </span>
                </button>
                <div className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}>
                  <div className="si09">
                    <div style={{ width: "100%", justifyContent: "space-between" }}>
                      <div className="lo-ad" style={{ background: "white", borderBottom: "1px solid white" }}>
                        <a href="/karle-dashboard" className="tail-text">
                          <h4 style={{ padding: "18px" }}>Karle</h4>
                        </a>
                      </div>
                      <div className="sidebar-close-icon">
                        <AiOutlineClose />
                      </div>
                    </div>
                    <ul>
                      <Link to="/karle-dashboard">
                        <li className="a-ele">
                          <span>
                            <MdOutlineSupportAgent style={{ fontSize: "20px" }} />
                          </span>
                          <span className="ms-2">Place Order</span>
                        </li>
                      </Link>
                      <Link to="/karle-order-history">
                        <li className="a-ele">
                          <span>
                            <FaHistory style={{ fontSize: "20px" }} />
                          </span>
                          <span className="ms-2">Order History</span>
                        </li>
                      </Link>
                    </ul>
                  </div>
                </div>
              </Navbar>
            </div>
          </div>

          <div className="right-admin main-content">
            <Modal show={showLogout} onHide={() => setShowLogout(false)} style={{ zIndex: "99999" }}>
              <Modal.Header closeButton>
                <Modal.Title>Warning</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="fs-4" style={{ color: "red" }}>
                  Are you sure? Do you want to Logout?
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="" className="modal-close-btn" onClick={() => setShowLogout(false)}>
                  Close
                </Button>
                <Button variant="" className="modal-add-btn" onClick={logOut}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>

            <div className="header">
              <div className="row justify-content-between align-items-center">
                <div
                  className="mb-3"
                  style={{ border: "1px solid #80808029", height: "80px", backgroundColor: "#80808029" }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ height: "100%", padding: "0 35px" }}
                  >
                    <h4 style={{ margin: 0 }}>Karle Dashboard</h4>
                    <AiOutlineLogout
                      style={{ fontSize: "40px", color: "orangered", cursor: "pointer" }}
                      onClick={() => setShowLogout(true)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KarleLayout;
